"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoundationItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
require("@/components/common/text/semantics/text-block");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * Foundations Overview에서 하위 문서로 이동하는 링크 카드.
 * 제목·설명은 text-block에 위임하고, 표면은 surface 면 선언에 elevated 그림자와 큰 반경을 얹어
 * hover에서 --interaction-hover-lift만큼 떠오른다.
 */
let FoundationItem = class FoundationItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
        this.heading = '';
        this.description = '';
    }
    render() {
        return (0, lit_1.html) `
      <a href=${this.href}>
        <mm-text-block
          level="3"
          heading=${this.heading}
          description=${this.description}
        ></mm-text-block>
      </a>
    `;
    }
};
FoundationItem.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      a {
        ${surface_styles_1.surfaceBaseStyles};
        --surface-height: 100%;
        --surface-border-radius: var(--radius-large);
        --surface-shadow: var(--material-elevated-shadow);
        --lift: none;

        transform: var(--lift);
        transition: box-shadow var(--transition-duration) var(--transition-easing),
          transform var(--transition-duration) var(--transition-easing);
      }

      ${shared_styles_1.interactiveElement}:hover {
        --lift: var(--interaction-hover-lift);
      }

      ${shared_styles_1.interactiveElement}:focus-visible {
        outline: var(--interaction-focus-outline);
        outline-offset: 2px;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FoundationItem.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FoundationItem.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FoundationItem.prototype, "description", void 0);
FoundationItem = __decorate([
    (0, decorators_js_1.customElement)('mm-foundation-item')
], FoundationItem);
exports.FoundationItem = FoundationItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm91bmRhdGlvbi1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZm91bmRhdGlvbi1pdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsK0VBQThFO0FBQzlFLHlEQUFzRDtBQUN0RCwrREFBNkU7QUFFN0U7Ozs7R0FJRztBQUVJLElBQU0sY0FBYyxHQUFwQixNQUFNLGNBQWUsU0FBUSxnQkFBVTtJQUF2Qzs7UUE4QnVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDVCxZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ1osZ0JBQVcsR0FBRyxFQUFFLENBQUE7SUFhOUMsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO2dCQUNDLElBQUksQ0FBQyxJQUFJOzs7b0JBR0wsSUFBSSxDQUFDLE9BQU87d0JBQ1IsSUFBSSxDQUFDLFdBQVc7OztLQUduQyxDQUFBO0lBQ0gsQ0FBQzs7QUEzQ00scUJBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsSUFBQSxTQUFHLEVBQUE7Ozs7OztVQU1HLGtDQUFpQjs7Ozs7Ozs7Ozs7UUFXbkIsa0NBQWtCOzs7O1FBSWxCLGtDQUFrQjs7OztLQUlyQjtDQUNGLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzRDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOytDQUFhO0FBQ1o7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO21EQUFpQjtBQWhDakMsY0FBYztJQUQxQixJQUFBLDZCQUFhLEVBQUMsb0JBQW9CLENBQUM7R0FDdkIsY0FBYyxDQTZDMUI7QUE3Q1ksd0NBQWMifQ==